import Vue from 'vue';
import axios from 'axios';
import {
  Product,
  FeatureFlags
} from '@/lib/utilities/enums';
import moment from 'moment';
import { HelperFunctions } from "@/lib/utilities/HelperFunctions.js";

function initialState() {
  return {
    stores: [],
    selectedStorePlatformID: 0,
    selectedStore: {},
    selectedConfiguration: {
      enableOneToOneOffer: false
    },
    storeHasOneToOne: true,
    offerTypes: ["Alert", "Flex", "Test"],
    selectedOfferTypes: ["Alert"],
    offerPopupPosition: '',
    excludeDomains: [],
    imDealers: [],
    saveSuccess: null,
    currentProduct: {},
    currentProductAlreadyExists: false
  }
}

function generateProduct(store) {
  var product = {
    ProductID: Product.OneToOne,
    ProductStatusID: 2,
    Name: 'OneToOne',
    AccountID: store.AccountID,
    AccountPlatformID: store.AccountPlatformID,
    Setup: null,
    MRR: null,
    Notes: null,
    OriginalSalesStaff: 'Kendall Billman',
    Features: [{
      FeatureID: FeatureFlags.OnlineOffer,
      Active: false,
      FeatureName: 'Online Offer',
      CreateUser: 'Kendall Billman',
      UpdateUser: 'Kendall Billman'
    }]
  };
  return product;
}

const state = initialState();

const actions = {
  getSelectedStores: function (context, user) {
    return new Promise((resolve, reject) => {
      if (user && user.ViewAllowedStores && user.ViewAllowedStores.length > 0) {
        context.commit('setStores', user.ViewAllowedStores.sort(HelperFunctions.sortByProperty('Name')));
        resolve(true);
      }
      else
        reject(false);
    })
  },
  setSelectedStore: function (context, data) {
    if (data) {
      context.commit('setSelectedStore', data);
    }
  },
  setCurrentProduct: function (context, data) {
    if (data) {
      context.commit('setCurrentProduct', data);
    }
  },
  loadConfiguration: function (context, data) {
    return new Promise((resolve, reject) => {
      context.commit('setStoreHasOneToOne', false);
      context.commit('setCurrentProductAlreadyExists', false);
      context.commit('setCurrentProduct', null);
      var requestUrl = '/products?accountId=' + data.AccountID + '&platformId=' + data.AccountPlatformID + '&productId=' + Product.OneToOne + '&productStatusId=0';
      Vue.http.get(requestUrl)
        .then(response => {
          if (response.data.Data.length > 0) {
            context.commit('setStoreHasOneToOne', true);
            context.commit('setCurrentProductAlreadyExists', true);
            context.commit('setCurrentProduct', response.data.Data[0]);
            for (var i = 0; i < response.data.Data[0].Features.length; i++) {
              if (response.data.Data[0].Features[i].FeatureID == FeatureFlags.OnlineOffer) {
                context.commit('setEnableOneToOneOffer', true);
                console.log('Activation feature found');
                resolve(response);
                return;
              }
            }
          } else if (context.state.imDealers && context.state.imDealers.length > 0) {
            for (var i = 0; i < context.state.imDealers.length; i++) {
              if (context.state.imDealers[i].DealerID == data.AutoAlertDealerID) {
                context.commit('setStoreHasOneToOne', true);
                context.commit('setCurrentProductAlreadyExists', false);
                context.commit('setCurrentProduct', generateProduct(context.state.selectedStore));
                resolve(response);
                return;
              }
            }

          } else {
            axios({
              method: 'get',
              url: 'https://dev-campaigns.autoalert.com/imapi/api/Dealer/GetAllOneToOneDealers',
              responsetype: 'json',
              headers: {
                'PartnerKey': 'c9836abc-deab-4a65-8d54-6bbce7c1f081'
              }
            }).then(function (response) {
              context.commit('updateIMDealersList', response.data.DealerList);
              for (var i = 0; i < response.data.DealerList.length; i++) {
                if (response.data.DealerList[i].DealerID == data.AutoAlertDealerID) {
                  context.commit('setStoreHasOneToOne', true);
                  context.commit('setCurrentProductAlreadyExists', false);
                  context.commit('setCurrentProduct', generateProduct(context.state.selectedStore));
                  resolve(response);
                  return;
                }
              }
            }).catch((error) => {
              console.log(error);
              context.commit('setStoreHasOneToOne', false);
              context.commit('setCurrentProductAlreadyExists', false);
              context.commit('setCurrentProduct', null);
            });

          }
          resolve(response);
        }).catch((error) => {
          console.log('Configuration could not be retrieved: ' + error);
          reject(error);
        });
    });
  },
  saveConfiguration: function (context, data) {
    var onlineActivationFound = false;
    var product = data.product;
    var activated = data.activated;

    if (!product)
      return;

      product = JSON.parse(JSON.stringify(product));
    if (product.LaunchDate == null) {
      product.LaunchDate = moment();
    }

    if (!product.Features)
      product.Features = [];
    else if (product.Features.length > 0) {
      for (var i = 0; i < product.Features.length; i++) {
        if (product.Features[i].FeatureID == FeatureFlags.OnlineOffer) {
          onlineActivationFound = true;
          product.Features[i].Active = activated;
          break;
        }
      }
    }

    if (!onlineActivationFound) {
      product.Features.push({
        FeatureID: FeatureFlags.OnlineOffer,
        Active: activated,
        FeatureName: 'Online Offer',
        CreateUser: 'Kendall Billman',
        UpdateUser: 'Kendall Billman'
      });
    }
    
    return new Promise((resolve, reject) => {
      Vue.http.post('products/saveproduct', product).then(response => {
        console.log('Configuration saved');
        resolve();
      }).catch((error) => {
        console.log('Configuration could not be saved: ' + error);
        reject(error);
      });
    });
  }
}

const mutations = {
  setStores(state, data) {
    state.stores = data;
    state.selectedStore = data[0];
  },
  updateIMDealersList: function (state, data) {
    state.imDealers = data;
  },
  setStoreHasOneToOne: function (state, data) {
    state.storeHasOneToOne = data;
  },
  displaySaveStatus(state, data) {
    state.saveSuccess = data;
  },
  setSelectedStore(state, data) {
    state.selectedStore = data;
  },
  setSelectedConfiguration(state, data) {
    state.selectedConfiguration = data;
  },
  setEnableOneToOneOffer(state, data) {
    state.selectedConfiguration.enableOneToOneOffer = data;
  },
  setCurrentProduct(state, data) {
    // if (data == null) {
    //   state.currentProduct = null;
    //   return;
    // } else
    //   state.currentProduct = {};

    // state.currentProduct.ProductID = data.ProductID;
    // state.currentProduct.ProductStatusID = data.ProductStatusID;
    // state.currentProduct.Name = data.Name;
    // state.currentProduct.AccountID = data.AccountID;
    // state.currentProduct.AccountPlatformID = data.AccountPlatformID;
    // state.currentProduct.Setup = data.Setup;
    // state.currentProduct.MRR = data.MRR;
    // state.currentProduct.Notes = data.Notes;
    // state.currentProduct.OriginalSalesStaff = data.OriginalSalesStaff;
    // state.currentProduct.Features = data.Features;
    state.currentProduct = data;
  },
  setCurrentProductAlreadyExists(state, data) {
    state.currentProductAlreadyExists = data;
  },
  gotConfiguration(state, data) {

  }
}

const getters = {
  stores: function (state) {
    return state.stores;
  },
  imDealers: function (state) {
    return state.imDealers;
  },
  storeHasOneToOne: function (state) {
    return state.storeHasOneToOne;
  },
  offerTypes: function (state) {
    return state.offerTypes;
  },
  selectedOfferTypes: function (state) {
    return state.selectedOfferTypes;
  },
  selectedStore: function (state) {
    return state.selectedStore;
  },
  selectedConfiguration: function (state) {
    return state.selectedConfiguration;
  },
  currentProduct: function (state) {
    return state.currentProduct;
  },
  enableOneToOneOffer: function (state) {
    return state.selectedConfiguration.enableOneToOneOffer;
  }
}

export default {
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/DealerFeatureConfiguration.js